<ng-container *ngIf="helpIconLinks$ | async as helpIconLinks">
  <ng-container *ngIf="helpIconLinks.size > 0">
    <div (openChange)="onChange($event)"
         ngbDropdown
         display="dynamic"
         autoClose="outside"
         placement="bottom-end bottom-center"
    >
      <div (keydown.enter)="openDropdown()" [class.active]="highlighted"
           class="highlightable-header-tab py-4 ms-2 ms-sm-4 ms-md-5 d-flex justify-content-center flex-column"
           data-cy="help-menu-toggle"
           ngbDropdownToggle
      >
        <div class="d-flex align-items-center">
          <span [tabIndex]="0"
                class="highlightable-header-tab__text ds-icon--help ds-icon--big focusable-round p-1"
                role="button" aria-expanded="false"
                [attr.aria-label]="'help.getHelp' | cxTranslate"
                [attr.title]="'help.getHelp' | cxTranslate"></span>
        </div>
      </div>
      <div class="help-menu__dropdown ngbdropdown-mobile-adjustment"
           ngbDropdownMenu
           data-cy="help-menu-dropdown-content">
        <dcp-help-icon-links [dropdown]="dropdown" [helpIconLinks]="helpIconLinks"></dcp-help-icon-links>
      </div>
    </div>
  </ng-container>
</ng-container>
